import { isNullOrUndefined } from 'util';

import { Account, User } from '../../models';
import { HumanAuthorities } from '../enums';
import { DELETE_USERS_AUTHORITIES_MAP, EDIT_USERS_AUTHORITIES_MAP } from '../constants';

export function checkIfCanDelete(user: User, activeUser: Account): boolean {
    if (isNullOrUndefined(activeUser) || isNullOrUndefined(user)) {
        return false;
    }
    if (activeUser.login === user.login) {
        return false;
    }
    const userAuthority = getHighestRole(user);
    let canDeleteRole = false;
    let canDeleteFaculty = true;
    for (const authority of activeUser.authorities) {
        if (!isNullOrUndefined(DELETE_USERS_AUTHORITIES_MAP[authority])) {
            for (const enabledAuthority of DELETE_USERS_AUTHORITIES_MAP[authority]) {
                if (userAuthority === enabledAuthority) {
                    canDeleteRole = true;
                }
            }
        }
    }
    if (getHighestRole(activeUser) === 'ROLE_ADMIN') {
        if (user.faculties.length === 0) {
            canDeleteFaculty = false;
        }
        for (const userFaculty of user.faculties) {
            if (activeUser.faculties.indexOf(userFaculty) === -1) {
                canDeleteFaculty = false;
            }
        }
    }
    return canDeleteRole && canDeleteFaculty;
}

export function checkIfCanEdit(user: User, activeUser: Account): boolean {
    if (isNullOrUndefined(activeUser) || isNullOrUndefined(user)) {
        return false;
    }
    if (activeUser.login === user.login) {
        return false;
    }
    const userAuthority = getHighestRole(user);
    let canEditRole = false;
    for (const authority of activeUser.authorities) {
        if (!isNullOrUndefined(EDIT_USERS_AUTHORITIES_MAP[authority])) {
            for (const enabledAuthority of EDIT_USERS_AUTHORITIES_MAP[authority]) {
                if (userAuthority === enabledAuthority) {
                    canEditRole = true;
                }
            }
        }
    }
    return canEditRole;
}

export function getHighestRole(model: User | Account): string {
    for (const authority of Object.keys(HumanAuthorities)) {
        for (const userAuthority of model.authorities) {
            if (authority === userAuthority) {
                return authority;
            }
        }
    }
    return null;
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/utils/user-utils.ts